import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import acceptInvitationApi from '@/features/public/acceptInvitation/api/acceptInvitationApi.ts';
import { AcceptInvitationDto } from '@/features/public/acceptInvitation/types/AcceptInvitationDto.ts';
import { queryClient } from '@/App.tsx';
import { storeCompanyId } from '@/features/dashboard/_root/access/currentCompany.ts';
import { userApiQueryKeys } from '@/features/dashboard/_root/api/userApi.queryKeys.ts';

export default function useAcceptInvitation() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: AcceptInvitationDto) => acceptInvitationApi.accept(data),
    onSuccess: (response) => {
      storeCompanyId(response.companyId);
      // Po wejściu do innej firmy wszystkie dane tenanta w cache są cudze.
      queryClient.clear();
      toast.success('Zaproszenie zostało zaakceptowane');
      navigate({ to: '/app' });
    },
    onError: (error) => {
      toast.error('Błąd', { description: error.message });
      // Anulowane lub wygasłe zaproszenie nie może zostać na liście jako martwa karta.
      queryClient.invalidateQueries({ queryKey: userApiQueryKeys.me() });
    },
  });
}
